import type { Segment } from './types';

export type SwapParts = {
  before: string;
  detail: string;
  after: string;
  /** What the detail becomes on the next swap. */
  next: string;
};

/**
 * Splits a swappable sentence around its detail, so the detail can be marked
 * where it sits. Null when the sentence has fewer than two alternatives.
 */
export function swapParts(segment: Segment): SwapParts | null {
  const { swap } = segment;

  if (!swap || swap.options.length < 2) {
    return null;
  }

  const index = swap.index % swap.options.length;

  return {
    before: swap.before,
    detail: swap.options[index],
    after: swap.after,
    next: swap.options[(index + 1) % swap.options.length],
  };
}
